import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DataContainer from 'Components/UI/DataContainer';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import PropTypes from 'prop-types';
import Content from './Content';

const styles = () => ({
  root: {
    margin: 'auto',
    height: '100vh',
  },
});

const PageContentContainer = ({ classes, navigationHeaderLeft, navigationHeaderRight }) => {
  const {
    isInitializing,
    pageContentLoadingErrors,
    pageSelfLinkParam,
  } = usePageContentContext();
  return (
    <DataContainer
      kay={pageSelfLinkParam}
      className={classes.root}
      component={Content}
      componentProps={{
        navigationHeaderLeft,
        navigationHeaderRight,
      }}
      loading={isInitializing}
      loadingError={pageContentLoadingErrors}
    />
  );
};

PageContentContainer.propTypes = {
  classes: PropTypes.object.isRequired,
  navigationHeaderLeft: PropTypes.object,
  navigationHeaderRight: PropTypes.object,
};
PageContentContainer.defaultProps = {
  navigationHeaderLeft: undefined,
  navigationHeaderRight: undefined,
};

export default withStyles(styles)(PageContentContainer);
